export default __webpack_public_path__ + "static/media/13.6d4fc2f0.png";